import { render, staticRenderFns } from "./WithdrawPreview.vue?vue&type=template&id=325cf67c&"
import script from "./WithdrawPreview.vue?vue&type=script&lang=js&"
export * from "./WithdrawPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports